// ImageSlider.jsx

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const CommonImageSlider = (props) => {
  return (
    <div className="w-full   mt-2 ms-0 me-0">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation={false}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        loop
        className="rounded-xl overflow-hidden shadow-md"
      >
        {props.images.map((img, idx) => (
          <SwiperSlide key={idx}>
            <div >
              <img
                src={img}
                alt={`Slide ${idx + 1}`}
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CommonImageSlider;
